export class AuthenticationService {
    constructor(config, api, restClientConfig) {
        this.api = api;
        this.restClientConfig = restClientConfig;
        this.tokenGetter = config.tokenGetter;
        this.tokenSetter = config.tokenSetter;
        this.tokenDeleter = config.tokenDeleter;
        this.useCookies = this.restClientConfig.useCookies;
    }
    login(email, password, keepLogged = true) {
        let params = {
            email: email,
            password: password,
            keeplogged: keepLogged
        };
        return this.loginGeneric('/user/token', params);
    }
    loginSSO(tokenName, token, provider, keepLogged = true) {
        let params = {
            [tokenName]: token,
            provider: provider,
            keeplogged: keepLogged
        };
        return this.loginGeneric('/user/token', params);
    }
    loginAgent(email, password, keepLogged = true) {
        let params = {
            email: email,
            password: password,
            keeplogged: keepLogged
        };
        return this.loginGeneric('/agent/token', params);
    }
    loginAgency(alias, password, keepLogged = true) {
        let params = {
            alias: alias,
            password: password,
            keeplogged: keepLogged
        };
        return this.loginGeneric('/agency/token', params);
    }
    hashLogin(hash, keepLogged = true) {
        let params = {
            hash: hash,
            keeplogged: keepLogged
        };
        return this.loginGeneric('/agency/token', params);
    }
    tokenParamLogin(tokenParam) {
        return this.api.get('user/token', { 'access_token': tokenParam, 'keep_token': true }).toPromise()
            .then(response => this.storeAccessToken(response));
    }
    absuidParamLogin(absuid) {
        return this.api.get('user/token', { 'absuid': absuid, 'keep_token': true }).toPromise()
            .then(response => this.storeAccessToken(response));
    }
    renewToken() {
        return this.renewTokenGeneric('/user/token');
    }
    renewTokenAgent() {
        return this.renewTokenGeneric('/agent/token');
    }
    renewTokenAgency() {
        return this.renewTokenGeneric('/agency/token');
    }
    logout() {
        return this.logoutGeneric('/user/token');
    }
    logoutAgent() {
        return this.logoutGeneric('/agent/token');
    }
    logoutAgency() {
        return this.logoutGeneric('/agency/token');
    }
    getAccessToken() {
        if (this.isTokenValid())
            return this.tokenGetter(this.useCookies, this.restClientConfig.getTokenKey).access_token;
        else {
            this.deleteAccessToken();
            return null;
        }
    }
    storeAccessToken(authToken) {
        this.tokenSetter(this.useCookies, authToken, this.restClientConfig.getTokenKey);
    }
    deleteAccessToken() {
        this.tokenDeleter(this.useCookies, this.restClientConfig.getTokenKey);
    }
    isTokenValid() {
        try {
            const token = this.tokenGetter(this.useCookies, this.restClientConfig.getTokenKey);
            if (!token)
                return false;
            return token &&
                new Date(token.expires_in.replace(/-/g, '/')) > new Date();
        }
        catch (error) {
            return false;
        }
    }
    isAgency() {
        const token = this.tokenGetter(this.useCookies, this.restClientConfig.getTokenKey);
        return token && token.id_agency && new Date(token.expires_in.replace(/-/g, '/')) > new Date();
    }
    isClient() {
        const token = this.tokenGetter(this.useCookies, this.restClientConfig.getTokenKey);
        return token && token.user_id && new Date(token.expires_in.replace(/-/g, '/')) > new Date();
    }
    isRegisteredClient() {
        const token = this.tokenGetter(this.useCookies, this.restClientConfig.getTokenKey);
        return token && token.user_id && token.user_id > 1 && new Date(token.expires_in.replace(/-/g, '/')) > new Date();
    }
    loginGeneric(endpoint, params) {
        return this.api.get(endpoint, params).toPromise()
            .then(response => this.storeAccessToken(response));
    }
    renewTokenGeneric(endpoint) {
        let access_token = this.getAccessToken();
        if (!access_token)
            return Promise.resolve();
        return this.api.get(endpoint, null, { headers: { 'Authorization': access_token } })
            .toPromise()
            .then(response => this.storeAccessToken(response));
    }
    logoutGeneric(endpoint) {
        let access_token = this.getAccessToken();
        if (!access_token)
            return Promise.resolve();
        this.deleteAccessToken();
        return Promise.resolve();
    }
}
//# sourceMappingURL=authentication.service.js.map